/* template */
<template minapp="mpx" xlang="wxml"><div :style='["width: 100%"] | transRpxStyle'><div :class="(isScramble ? 'train-list-condition-container-scramble' : 'train-list-condition-container')"><div :class="(isScramble ? 'train-list-condition-bar-scramble' : 'train-list-condition-bar')" :style="[(safePadding)] | transRpxStyle"><mpx-view :class="({select: startTimeSelected})" @tap="showSortCriteriaDrawer('start')" class="bar-item">{{ startTimeBar }}</mpx-view><mpx-view :class="({select: travelTimeSelected})" @tap="showSortCriteriaDrawer('time')" class="bar-item">{{ travelTimeBar }}</mpx-view><mpx-view :class="({select: priceSelected})" @tap="showSortCriteriaDrawer('price')" class="bar-item">{{ priceBar }}</mpx-view><mpx-view @tap="showFilterConditionDrawer" class="bar-item"><div class="icon"></div>筛选<div class="number" v-if="(conditionNumber)">{{ conditionNumber }}</div></mpx-view></div></div><train-list-filter-condition-drawer :show="(filterConditionDrawerVisible)" :trainListSearchQuery="(trainListSearchQuery)" :selectCityList="(selectCityList)" :condition="(condition)" :isScramble="(isScramble)" :unionType="(unionType)" @parentDataChange="parentDataChange" @conditionChange="conditionChange" @close="hiddenFilterConditionDrawer" @getTrainListFunc="getTrainListFunc"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m54224a61"}'>
  @import '~@/mixins/stylus/color.styl'

  .train-list-condition-container
    // margin-left 8px
    // width calc(100% - 16px)
    width 100%
    position relative
    // height 76px
    background #f3f4f5
    border-radius 16px 16px 0 0
  .train-list-condition-container-scramble
    width 100%
    position sticky
    top 0
    left 0
    height 52px
  .train-list-condition-bar
    // width calc(100% - 16px)
    width 100%
    height 52px
    line-height 52px
    background #ffffff
    box-shadow 0 12px 12px 0 RGBA(0, 0, 0, 0.06)
    position relative
    border-radius 12px
    display flex
    justify-content space-between
    align-items center
  .train-list-condition-bar-scramble
    width 100%
    height 52px
    line-height 52px
    background #ffffff
    position fixed
    display flex
    justify-content space-between
    align-items center
  .split-line
    display flex
    align-items center
  .split-line::before
    width 1px
    height 14px
    background #e6e6e6
    content ' '
  .bar-item
    flex 1
    color #222222
    font-size 14px
    font-weight 400
    display flex
    justify-content center
    align-items center
    position relative
    .icon
      margin-left 2px
  .bar-item.select
    color #222222
    font-family PingFangSC-Medium
    position relative
    &::before
      position absolute
      content ''
      height 4px
      width 10px
      background #FF6400
      border-radius 2px
      bottom 11px
      left 42px
  .icon
    width 10.5px
    height 11px
    background url('https://dpubstatic.udache.com/static/dpubimg/ChGvbgZKpfdbTlvpaQRIU.png')
    background-size cover
    margin-right 2px
  .number
    width 12.5px
    height 12.5px
    border-radius 50%
    background #FF4129
    color #FFFFFF
    font-size 9px
    line-height 12.5px
    text-align center
    position absolute
    top 12px
    right 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m54224a61"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex54224a61%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex54224a61%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m54224a61"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index54224a61/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'train-list-filter-condition-drawer':getComponent(require("./train-list-filter-condition-drawer/index.mpx?isComponent&outputPath=components%2Findex57b87110%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
